<template>
  <div class="header">
    <el-header>
      <div class="title">
        <img src="@/assets/NuoWan.png" alt="" />
        <i class="el-icon-menu" @click="handleMenuShow"></i>
      </div>
      <div class="right">
        <i class="el-icon-user-solid"></i>
        <div class="info1">
          <a class="logined">{{ curUserName }}</a>
          <a class="logined" style="cursor: pointer" @click="logout"
            >退出登录</a
          >
        </div>
      </div>
    </el-header>
  </div>
</template>

<script>
  import eventBus from "@/utils/eventBus";
  import { getName } from "@/utils/setToken";
  export default {
    data() {
      return {
        showMenu: true,
      };
    },
    computed: {
      curUserName() {
        // return this.$store.state.auth.curUserInfo.name;
        return getName("name")
      },
    },
    methods: {
      async logout() {
        try {
          await this.$store.dispatch("userLogout");
          await this.$router.push("./login");
        } catch (error) {
          console.log("err");
        }
      },
      handleMenuShow() {
        this.showMenu = !this.showMenu;
        eventBus.$emit("menuShow", this.showMenu); // 触发自定义事件并传递数据
      },
    },
  };
</script>

<style lang="scss" scoped>
  .header {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    .el-header {
      display: flex;
      height: 60px;
      background-color: #305680;
      color: #fff;
      line-height: 60px;
      justify-content: space-between;
      padding: 0;
      .title {
        width: 240px;
        display: flex; /* 使用 Flexbox 布局 */
        align-items: center; /* 垂直居中对齐 */
        img {
          width: 75%;
          height: 100%;
        }
        .el-icon-menu {
          font-size: 20px;
          margin: 0 auto;
          display: block;
          cursor: pointer;
        }
      }
      .right {
        width: 200px;
        font-size: 14px;
        margin: 0 10px;
        .el-icon-user-solid {
          float: left;
          font-size: 20px;
          line-height: 60px;
          margin-right: 10px;
        }
        .info1 {
          display: flex;
          flex-direction: column;
          margin: 5px 0;
        }
        .logined {
          line-height: 27px;
        }
      }
    }
  }
</style>
